import { service } from '../../../../helpers/http' 

export const ActionGetUsers = ({ dispatch }, payload) => { 
    return service({
        module: 'domainUser',
        action: 'getUsers',
        payload: payload
    })
}

export const ActionPostUsers = ({ dispatch }, payload) => {

    return service({
        module: 'domainUser',
        action: 'postUsers',
        payload: payload
    })
    
}

export const ActionPutUsers = ({ dispatch }, payload) => {

    return service({
        module: 'domainUser',
        action: 'putUsers',
        payload: payload
    })
    
}

export const ActionDeleteUsers = ({ dispatch }, payload) => {

    return service({
        module: 'domainUser',
        action: 'deleteUsers',
        payload: payload
    })
    
}
